// Reference lines, as a fraction of the viewport height measured from its top.
const START_LINE = 0.75
const END_LINE = 0.5

export default () => ({
  _frame: 0,
  _updateHandler: null as (() => void) | null,

  init() {
    this._updateHandler = () => this.schedule()

    window.addEventListener('scroll', this._updateHandler, { passive: true })
    window.addEventListener('resize', this._updateHandler, { passive: true })

    this.update()
  },

  destroy() {
    if (this._frame) cancelAnimationFrame(this._frame)

    if (this._updateHandler) {
      window.removeEventListener('scroll', this._updateHandler)
      window.removeEventListener('resize', this._updateHandler)
    }
  },

  schedule() {
    if (this._frame) return

    this._frame = requestAnimationFrame(() => {
      this._frame = 0
      this.update()
    })
  },

  update() {
    const bar = this.$refs.bar as HTMLElement | undefined
    if (!bar) return

    const rect = this.$el.getBoundingClientRect()
    const start = window.innerHeight * START_LINE
    const end = window.innerHeight * END_LINE

    const progress = (start - rect.top) / (rect.height + start - end)

    bar.style.setProperty('--timeline-progress', String(Math.min(1, Math.max(0, progress))))
  },
})
